import { useSuggestedKeywordsQuery } from "@graphql/generated/graphql";
import { ArrowTrendingUpIcon } from "@heroicons/react/20/solid";
import { errorToastPopup } from "@lib/errorToastPopup";
import { Trans } from "@lingui/macro";
import Link from "next/link";
import { useRouter } from "next/router";
import { useEffect, useMemo } from "react";

const SideBarTrendingKeywords = () => {
  const {
    query: { search },
    pathname,
    locale,
  } = useRouter();
  const { data, loading, error, refetch } = useSuggestedKeywordsQuery({
    variables: { languageCode: locale },
  });

  const trendingKeywords = useMemo(() => {
    if (loading || !data.suggestedKeywords) {
      return [];
    }

    if (pathname.includes("/explore") && search) {
      return data.suggestedKeywords.filter((keywords) => keywords !== search);
    } else {
      return data.suggestedKeywords;
    }
  }, [data, loading, pathname, search]);

  useEffect(() => {
    refetch({ languageCode: locale });
  }, [locale, refetch]);

  useEffect(() => {
    if (error) {
      errorToastPopup(error);
    }
  }, [error]);

  return (
    <div className="flex flex-col space-y-6">
      <p className="font-poppins text-lg font-bold text-text-darkest">
        <Trans>Trending now</Trans>
      </p>
      <div className="flex flex-wrap">
        {trendingKeywords.map((keyword) => (
          <TrendingKeywordPill key={keyword} keyword={keyword} />
        ))}
      </div>
    </div>
  );
};

const TrendingKeywordPill = ({ keyword }) => {
  const parseQuery = (keyword) => {
    return keyword.split(" ").join("+");
  };

  return (
    <Link href={`/explore?search=${parseQuery(keyword)}`} passHref>
      <div className="mb-2 mr-2 flex flex-row items-center space-x-1 rounded-2xl bg-off-white px-4 py-2 hover:cursor-pointer">
        <ArrowTrendingUpIcon className="h-6 w-6 text-primary2" />
        <p className="text-darkest text-md text-center font-sen font-normal">
          {keyword}
        </p>
      </div>
    </Link>
  );
};

export default SideBarTrendingKeywords;
